import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface CopyableReadonlyFieldProps {
  className?: string
  copyLabel: string
  label: string
  labelClassName?: string
  monospace?: boolean
  onCopy: () => void
  prefix?: ReactNode
  showLabel?: boolean
  value: string
}

export function CopyableReadonlyField({
  className,
  copyLabel,
  label,
  labelClassName,
  monospace,
  onCopy,
  prefix,
  showLabel = false,
  value,
}: CopyableReadonlyFieldProps) {
  return (
    <div className={cn(showLabel ? 'grid gap-1.5' : null, className)}>
      {showLabel ? (
        <span className={cn('text-sm font-medium text-[var(--color-text)]', labelClassName)}>
          {label}
        </span>
      ) : null}
      <div className="relative">
        {prefix ? (
          <span className="pointer-events-none absolute top-1/2 left-2.5 z-10 -translate-y-1/2">
            {prefix}
          </span>
        ) : null}
        <input
          aria-label={label}
          className={cn(
            'h-9 w-full rounded-md border border-[var(--color-border)] bg-[var(--color-surface-muted)] px-3 pr-11 font-medium text-[var(--color-text)] outline-none',
            prefix ? 'pl-12' : '',
            monospace ? 'font-mono text-xs' : 'text-sm',
          )}
          readOnly
          value={value}
        />
        <button
          aria-label={copyLabel}
          className="absolute inset-y-px right-px flex w-9 cursor-pointer items-center justify-center rounded-r-[5px] border-l border-[var(--color-border)] text-[var(--color-text-muted)] transition-colors hover:bg-white hover:text-[var(--color-primary)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[var(--color-focus)]"
          onClick={onCopy}
          title={copyLabel}
          type="button"
        >
          <svg aria-hidden className="size-4" fill="none" viewBox="0 0 16 16">
            <path
              d="M6 5.5V4.25A1.25 1.25 0 0 1 7.25 3h4.5A1.25 1.25 0 0 1 13 4.25v4.5A1.25 1.25 0 0 1 11.75 10H10.5M4.25 6h4.5A1.25 1.25 0 0 1 10 7.25v4.5A1.25 1.25 0 0 1 8.75 13h-4.5A1.25 1.25 0 0 1 3 11.75v-4.5A1.25 1.25 0 0 1 4.25 6Z"
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="1.4"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}
